import React, { FC, forwardRef } from 'react';
import DatePicker from 'react-datepicker';
import { TouchableOpacity } from 'react-native';

import 'react-datepicker/dist/react-datepicker.css';
import styled from 'styled-components/native';
import DateTimeFieldDisplay from './DateTimeFieldDisplay';

interface DateTimeFieldProps {
  value: Date;
  onChange?: (date: Date) => void;
}

const DateTimeField: FC<DateTimeFieldProps> = ({ value, onChange }) => {
  // eslint-disable-next-line react/display-name
  const Input = forwardRef(({ onClick }, ref) => (
    <TouchableOpacity ref={ref} onPress={onClick}>
      <DateTimeFieldDisplay value={value} />
    </TouchableOpacity>
  ));

  const handleChange = (val: Date) => {
    onChange && onChange(val);
  };

  return (
    <Container>
      <DatePicker
        selected={value}
        onChange={handleChange}
        showTimeSelect
        customInput={<Input />}
        timeIntervals={5}
      />
    </Container>
  );
};

const Container = styled.View`
  flex-direction: row;
  z-index: unset;
`;

export default DateTimeField;
